import { render, staticRenderFns } from "./Praticien.vue?vue&type=template&id=5170a963&scoped=true&"
import script from "./Praticien.vue?vue&type=script&lang=js&"
export * from "./Praticien.vue?vue&type=script&lang=js&"
import style0 from "./Praticien.vue?vue&type=style&index=0&id=5170a963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170a963",
  null
  
)

export default component.exports